<tui-root>
    <router-outlet #outlet="outlet"></router-outlet>

  <ng-container ngProjectAs="tuiOverContent">
    <div #componentContainer></div>
  </ng-container>
  <ng-container ngProjectAs="tuiOverHints">
    <!-- Content over hints -->
  </ng-container>

  <ng-container ngProjectAs="tuiOverDialogs">
    <div class="custom-overlay-container"></div>


  <ngx-sonner-toaster richColors="true" />
  </ng-container>
</tui-root>
